import React, { useState, useEffect } from "react";

const App = () => {
  const [showFloatingBtn, setShowFloatingBtn] = useState(false);
  // 전화번호 상태 관리
  const [phone, setPhone] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingBtn(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, "");
    let formattedValue = rawValue;

    if (rawValue.length > 11) {
      formattedValue = rawValue.slice(0, 11);
    }

    if (rawValue.length > 3 && rawValue.length <= 7) {
      formattedValue = `${rawValue.slice(0, 3)}-${rawValue.slice(3)}`;
    } else if (rawValue.length > 7) {
      formattedValue = `${rawValue.slice(0, 3)}-${rawValue.slice(
        3,
        7
      )}-${rawValue.slice(7, 11)}`;
    }

    setPhone(formattedValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const userName = formData.get("name");

    const GOOGLE_FORM_URL =
      "https://docs.google.com/forms/d/e/1FAIpQLSd1BlGNdAbh0kHrZrE3MSs39RFRxd3DUlRgHVp3NnQ7OcXoTg/formResponse";

    const submitData = new FormData();
    submitData.append("entry.105819737", formData.get("name"));
    submitData.append("entry.648292849", formData.get("phone"));
    submitData.append("entry.1725082665", formData.get("email"));
    submitData.append("entry.540185586", formData.get("source"));

    fetch(GOOGLE_FORM_URL, {
      method: "POST",
      mode: "no-cors",
      body: submitData,
    })
      .then(() => {
        if (
          window.confirm(
            `환영합니다, ${userName}님!\n\nFuture League 사전 예약이 완료되었습니다.\n2026년 1월 14일, 오픈 멤버 패키지가 발송됩니다.`
          )
        ) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          form.reset();
          setPhone("");
        }
      })
      .catch((err) => {
        alert("접수 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        console.error("Form Submit Error:", err);
      });
  };

  return (
    <div className="app-wrapper">
      <style>{`
        /* --- 기본 설정 --- */
        :root {
            --bg-color: #0F0F0F;
            --surface-color: #1A1A1A;
            --surface-card: #222;
            --text-main: #FFFFFF;
            --text-sub: #ADB5BD;
            --primary-purple: #9D4EDD;
            --accent-mint: #00FFD1;
            --gold: #FFD700;
            --danger-red: #FF4D4D;
            --font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        html { scroll-behavior: smooth; }

        .app-wrapper {
            box-sizing: border-box;
            font-family: var(--font-family);
            background-color: var(--bg-color);
            color: var(--text-main);
            line-height: 1.75;
            min-height: 100vh;
            width: 100%;
            overflow-x: hidden;
            padding-bottom: 140px;
        }
        
        .app-wrapper * { box-sizing: border-box; margin: 0; padding: 0; }
        .app-wrapper ul { list-style: none; }
        .app-wrapper a { text-decoration: none; }

        .container {
            max-width: 500px;
            margin: 0 auto;
            padding: 0 28px;
        }

        .section { padding: 120px 0; } 
        .text-center { text-align: center; }
        
        .text-gradient {
            background: linear-gradient(90deg, var(--accent-mint), var(--primary-purple));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 800;
        }
        
        .text-gold { color: var(--gold); font-weight: bold; }
        .text-purple { color: var(--primary-purple); font-weight: bold; }
        .text-mint { color: var(--accent-mint); font-weight: bold; }

        /* --- Hero Section --- */
        .hero {
            padding-top: 80px;
            padding-bottom: 80px;
            text-align: center;
        }

        .badge-limit {
            display: inline-block;
            background: rgba(255, 77, 77, 0.15);
            color: var(--danger-red);
            padding: 10px 20px;
            border-radius: 30px;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 32px;
            border: 1px solid rgba(255, 77, 77, 0.4);
            box-shadow: 0 0 15px rgba(255, 77, 77, 0.2);
            animation: pulse-red 2s infinite;
        }
        @keyframes pulse-red {
            0% { box-shadow: 0 0 0 0 rgba(255, 77, 77, 0.2); }
            70% { box-shadow: 0 0 0 8px rgba(255, 77, 77, 0); }
            100% { box-shadow: 0 0 0 0 rgba(255, 77, 77, 0); }
        }

        .hero h1 {
            font-size: 38px;
            line-height: 1.35;
            margin-bottom: 30px;
            font-weight: 800;
            letter-spacing: -1px;
            word-break: keep-all; /* 단어 단위로 줄바꿈 (글자 잘림 방지) */
        }

        @media (max-width: 480px) {
            .hero h1 { font-size: 28px; }
        }

        .hero-sub { 
            display: block;
            color: var(--text-sub); 
            font-size: 16px; 
            margin-bottom: 16px; 
            letter-spacing: 0;
            font-weight: 500;
            line-height: 1.5;
        }

        .launch-date-box {
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid var(--primary-purple);
            padding: 16px 24px;
            border-radius: 16px;
            display: inline-block;
            margin-bottom: 40px;
            box-shadow: 0 0 20px rgba(157, 78, 221, 0.2);
            width: 100%;
        }
        .launch-label { display: block; font-size: 13px; color: #aaa; margin-bottom: 6px; }
        .launch-date { display: block; font-size: 22px; font-weight: 800; color: #fff; letter-spacing: -0.5px; }
        
        .hero p {
            color: var(--text-sub);
            font-size: 17px;
            margin-bottom: 50px;
            line-height: 1.7;
        }
        .hero strong { color: #fff; font-weight: 600; }

        .alert-box {
            background: rgba(157, 78, 221, 0.08);
            border: 1px solid rgba(157, 78, 221, 0.3);
            border-radius: 20px;
            padding: 24px;
            margin: 40px 0;
            text-align: left;
            font-size: 15px;
        }
        .alert-title { color: var(--primary-purple); font-weight: bold; margin-bottom: 10px; font-size: 16px; }

        /* --- App Screenshot Section --- */
        .preview-scroll-container {
            display: flex;
            overflow-x: auto;
            gap: 20px;
            padding: 20px 10px 40px 10px; 
            -webkit-overflow-scrolling: touch;
            scroll-snap-type: x mandatory;
        }
        .preview-scroll-container::-webkit-scrollbar { display: none; }

        .phone-mockup {
            flex: 0 0 260px; 
            height: 520px;
            background-color: #000;
            border-radius: 40px; 
            border: 12px solid #2a2a2a; 
            box-shadow: 0 20px 50px rgba(0,0,0,0.8), inset 0 0 20px rgba(255,255,255,0.1);
            overflow: hidden;
            position: relative;
            scroll-snap-align: center;
        }
        
        .phone-mockup img {
            width: 100%; height: 100%;
            object-fit: cover;
            display: block;
        }

        /* --- Features --- */
        .feature-grid { 
            display: grid; 
            grid-template-columns: 1fr 1fr; 
            gap: 20px;
            margin-top: 40px; 
        }
        .feature-card {
            background-color: var(--surface-color);
            border-radius: 24px;
            padding: 28px 20px;
            border: 1px solid #333;
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        }
        .feature-icon { font-size: 32px; margin-bottom: 16px; }
        .feature-title { font-size: 18px; font-weight: bold; margin-bottom: 10px; color: #fff; }
        .feature-desc { font-size: 14px; color: var(--text-sub); line-height: 1.6; }

        /* --- Steps --- */
        .step-container {
            display: flex;
            justify-content: space-between;
            background: var(--surface-color);
            padding: 30px 10px;
            border-radius: 24px;
            margin-top: 40px;
            gap: 5px;
        }
        .step-box { text-align: center; flex: 1; position: relative; }
        .step-box:not(:last-child)::after {
            content: "›";
            position: absolute;
            right: -8px; top: 50%; transform: translateY(-55%);
            color: #444; font-size: 24px;
        }
        .step-emoji { font-size: 28px; display: block; margin-bottom: 12px; }
        .step-label { font-size: 13px; font-weight: bold; color: #ccc; display: block; margin-bottom: 6px; }
        .step-desc { font-size: 12px; color: #777; }

        /* --- Rewards --- */
        .reward-card {
            background: linear-gradient(145deg, #1e1e1e, #141414);
            border: 1px solid #333;
            border-radius: 24px;
            padding: 30px 24px;
            margin-bottom: 24px;
            display: flex;
            align-items: center;
            gap: 24px;
        }
        .reward-img { 
            font-size: 36px; 
            background: #2a2a2a; 
            width: 70px; height: 70px; 
            min-width: 70px;
            display: flex; align-items: center; justify-content: center; 
            border-radius: 20px; 
        }
        .reward-info h4 { font-size: 18px; margin-bottom: 8px; color: #fff; }
        .reward-info p { font-size: 15px; color: #aaa; line-height: 1.5; }

        /* --- Form --- */
        .form-container {
            background-color: var(--surface-card);
            padding: 50px 28px;
            border-radius: 32px;
            border: 1px solid #333;
            box-shadow: 0 10px 40px rgba(0,0,0,0.6);
            position: relative;
            overflow: hidden;
        }
        .form-container::before {
            content: "";
            position: absolute;
            top: 0; left: 0; width: 100%; height: 6px;
            background: linear-gradient(90deg, var(--accent-mint), var(--primary-purple));
        }

        .form-group { margin-bottom: 32px; } 
        .form-label { display: block; font-size: 16px; color: var(--text-sub); margin-bottom: 12px; font-weight: 500; }
        .form-input, .form-select {
            width: 100%;
            padding: 20px;
            background-color: #121212;
            border: 1px solid #444;
            border-radius: 16px;
            color: #fff;
            font-size: 17px;
            outline: none;
            transition: 0.2s;
        }
        .form-input:focus, .form-select:focus { 
            border-color: var(--primary-purple); 
            box-shadow: 0 0 0 2px rgba(157, 78, 221, 0.2);
        }
        
        .privacy-box {
            background-color: #151515;
            padding: 24px;
            border-radius: 16px;
            border: 1px solid #333;
            margin-top: 40px;
            margin-bottom: 30px;
        }
        .privacy-text {
            font-size: 13px;
            color: #888;
            margin-bottom: 20px;
            line-height: 1.7;
            padding-bottom: 20px;
            border-bottom: 1px solid #333;
        }
        
        .checkbox-group { display: flex; align-items: flex-start; gap: 14px; margin-bottom: 16px; }
        .checkbox-group input { margin-top: 5px; accent-color: var(--primary-purple); width: 20px; height: 20px; }
        .checkbox-label { font-size: 15px; color: var(--text-sub); line-height: 1.6; cursor: pointer; flex: 1; }
        .checkbox-label span { color: var(--accent-mint); font-weight: bold; }

        .cta-button {
            width: 100%;
            padding: 22px;
            background: linear-gradient(90deg, var(--primary-purple), #7b2cbf);
            color: white;
            font-size: 20px;
            font-weight: 800;
            border: none;
            border-radius: 18px;
            cursor: pointer;
            box-shadow: 0 4px 15px rgba(138, 43, 226, 0.4);
            transition: all 0.3s;
            margin-top: 10px;
        }
        .cta-button:hover { transform: translateY(-2px); filter: brightness(1.1); }

        .floating-cta {
            position: fixed;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%) translateY(120px);
            width: 90%;
            max-width: 460px;
            background: linear-gradient(90deg, var(--accent-mint), var(--primary-purple));
            color: #000;
            padding: 18px;
            border-radius: 50px;
            text-align: center;
            font-weight: 800;
            font-size: 17px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.6);
            z-index: 1000;
            opacity: 0;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            text-decoration: none;
            border: 3px solid #fff;
        }
        .floating-cta.visible { transform: translateX(-50%) translateY(0); opacity: 1; }
        
        footer { text-align: center; padding: 80px 20px; color: #555; font-size: 14px; }
      `}</style>

      {/* --- Hero Section --- */}
      <header className="container hero">
        <div className="badge-limit">🔥 선착순 1,000명 마감 임박</div>

        <span className="hero-sub">
            <span style={{color:'var(--accent-mint)', fontWeight:'bold', fontSize:'18px'}}>한국판 합법 폴리마켓</span><br/>
            Future League 사전 예약
        </span>

        {/* [수정] 3줄로 연결되면서 모바일에서도 자연스러운 스타일 */}
        <h1>
          매일 버려지는<br/>
          당신의 직감,<br/>
          <span className="text-gradient"> 자산으로 바꾸세요</span>
        </h1>

        {/* 오픈일 강조 박스 */}
        <div className="launch-date-box">
            <span className="launch-label">BETA TEST OPEN</span>
            <span className="launch-date">2026. 01. 14 (수)</span>
        </div>

        <p>
          방구석 훈수는 그만.<br />
          주식, 코인, 축구, 연예...<br />
          <strong>당신의 '촉'이 곧 자산이 됩니다.</strong>
        </p>

        <div className="alert-box">
          <div className="alert-title">⚠️ 중요 안내</div>
          <div style={{ fontSize: "15px", color: "#ccc", lineHeight: "1.6" }}>
            현재 예약자 폭주로 인해{" "}
            <strong style={{ color: "#fff", textDecoration: "underline" }}>
              오픈 멤버 패키지
            </strong>{" "}
            지급이 조기 종료될 수 있습니다.
          </div>
        </div>

        <div>
          <a
            href="#pre-register"
            style={{
              textDecoration: "none",
              display: "inline-block",
              padding: "18px 36px",
              background: "rgba(255,255,255,0.08)",
              border: "1px solid #555",
              borderRadius: "40px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            👇 10초 만에 '사전 예약' 하기
          </a>
        </div>
      </header>

      {/* --- App Screenshot Section --- */}
      <section className="container section text-center">
        <h2 style={{marginBottom: "40px"}}>
            직감으로 승부하는<br/>
            <span className="text-gradient">실제 플레이 화면</span>
        </h2>
        
        <div className="preview-scroll-container">
            {/* 화면 1 */}
            <div className="phone-mockup">
                <img src="https://i.imgur.com/meuV5nD.png" alt="메인 홈 화면" />
            </div>

            {/* 화면 2 */}
            <div className="phone-mockup">
                 <img src="https://i.imgur.com/rNEp2XT.jpeg" alt="OX 투표 화면 1" />
            </div>

            {/* 화면 3 */}
            <div className="phone-mockup">
                 <img src="https://i.imgur.com/o08AYls.jpeg" alt="OX 투표 화면 2" />
            </div>

            {/* 화면 4 */}
            <div className="phone-mockup">
                 <img src="https://i.imgur.com/GGU3Jy5.jpeg" alt="랭킹 화면" />
            </div>
        </div>
        <p style={{color:'#666', fontSize:'13px', marginTop:'20px'}}>↔ 좌우로 스크롤하여 확인해보세요</p>
      </section>

      {/* --- Key Features --- */}
      <section className="container section">
        <h2 className="text-center" style={{ marginBottom: "20px" }}>
          리스크 0원,
          <br />
          <span className="text-purple">보상은 확실하게</span>
        </h2>
        <p
          className="text-center"
          style={{
            color: "var(--text-sub)",
            fontSize: "16px",
            marginBottom: "40px",
          }}
        >
          돈 한 푼 들지 않는 '무위험 예측 플랫폼'입니다.
        </p>

        <div className="feature-grid">
          <div className="feature-card">
            <div className="feature-icon">🔮</div>
            <div className="feature-title">리스크 0원</div>
            <div className="feature-desc">
              돈을 걸지 않습니다. 100% 무료로 즐기고 보상만 챙기세요.
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📈</div>
            <div className="feature-title">모든 것이 종목</div>
            <div className="feature-desc">
              비트코인, 삼성전자부터 손흥민 골, 넷플릭스 1위까지.
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <div className="feature-title">100% 실력 승부</div>
            <div className="feature-desc">
              남들의 선택은 보이지 않습니다. 군중심리 없이 오직 직감으로!
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <div className="feature-title">PnL = 골드(G)</div>
            <div className="feature-desc">
              게임 점수는 시즌 종료 시 1:1 비율로 내 자산(Gold)이 됩니다.
            </div>
          </div>
        </div>
      </section>

      {/* --- Legal Notice --- */}
      <section className="container">
        <div
          style={{
            background: "#222",
            padding: "30px",
            borderRadius: "20px",
            borderLeft: "4px solid #ffd700",
            fontSize: "15px",
            color: "#ccc",
            lineHeight: "1.7",
          }}
        >
          <strong
            style={{
              color: "#ffd700",
              display: "block",
              marginBottom: "10px",
              fontSize: "16px",
            }}
          >
            ⚠️ 서비스 중요 고지 (Legal Notice)
          </strong>
          • 본 서비스는 실제 금전을 배팅하는 도박이 아닙니다.
          <br />• 현금 충전, 환전 기능은 절대 제공되지 않으며, 획득한 포인트는
          실물 경품(기프티콘 등)으로만 교환 가능합니다.
        </div>
      </section>

      {/* --- How to Play --- */}
      <section className="container section text-center">
        <h2>
          참여는 10초,
          <br />
          <span className="text-gradient">보상은 크게.</span>
        </h2>
        <div className="step-container">
          <div className="step-box">
            <span className="step-emoji">👁️</span>
            <span className="step-label">READ</span>
            <span className="step-desc">이슈 확인</span>
          </div>
          <div className="step-box">
            <span className="step-emoji">⚡</span>
            <span className="step-label">PICK</span>
            <span className="step-desc">O or X</span>
          </div>
          <div className="step-box">
            <span className="step-emoji">💸</span>
            <span className="step-label">EARN</span>
            <span className="step-desc">점수 획득</span>
          </div>
          <div className="step-box">
            <span className="step-emoji">🏆</span>
            <span className="step-label">ASSET</span>
            <span className="step-desc">골드 전환</span>
          </div>
        </div>
      </section>

      {/* --- Rewards Section (OG Benefits) --- */}
      <section className="container section">
        <h2 className="text-center" style={{ marginBottom: "40px" }}>
          사전 예약만의
          <br />
          <span className="text-mint">압도적인 혜택</span>
        </h2>

        <div className="reward-card">
          <div className="reward-img">🥇</div>
          <div className="reward-info">
            <h4>오픈 멤버 Badge (영구)</h4>
            <p>시즌 1부터 함께한 멤버임을 증명하는 한정판 프로필 뱃지</p>
          </div>
        </div>
        <div className="reward-card">
          <div className="reward-img">🎒</div>
          <div className="reward-info">
            <h4>오픈 멤버 패키지 (즉시 지급)</h4>
            <p>무료 예측 티켓 5장 + 퓨처스 티켓(장기 투자용) 3장</p>
          </div>
        </div>
        <div className="reward-card">
          <div className="reward-img">🎁</div>
          <div className="reward-info">
            <h4>Top 70%까지 시즌 보상</h4>
            <p>상위권이 아니어도 꽝 없는 랜덤 박스(골드/포인트) 100% 지급</p>
          </div>
        </div>
      </section>

      {/* --- Registration Form --- */}
      <section id="pre-register" className="container section">
        <div className="form-container">
          <h2 className="text-center" style={{ marginBottom: "20px" }}>
            미래를 읽는 눈이 있다면,
          </h2>
          <p
            className="text-center"
            style={{
              marginBottom: "50px",
              color: "var(--text-sub)",
              fontSize: "16px",
            }}
          >
            지금 사전 예약하고 가장 먼저 자산(G)을 쌓으세요.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">이름</label>
              <input
                type="text"
                name="name"
                className="form-input"
                placeholder="홍길동"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">휴대폰 번호</label>
              <input
                type="tel"
                name="phone"
                className="form-input"
                placeholder="010-1234-5678"
                required
                value={phone} // 제어된 컴포넌트로 변경
                onChange={handlePhoneChange} // 자동 하이픈 함수 연결
                maxLength={13} // 하이픈 포함 13자리 제한
              />
            </div>

            <div className="form-group">
              <label className="form-label">이메일 주소</label>
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="example@email.com"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">알게 된 경로</label>
              <select
                className="form-select"
                name="source"
                required
                defaultValue=""
              >
                <option value="" disabled>
                  선택해주세요
                </option>
                <option value="community">커뮤니티</option>
                <option value="instagram">인스타그램</option>
                <option value="youtube">유튜브</option>
                <option value="tiktok">틱톡</option>
                <option value="friends">지인 추천</option>
                <option value="etc">기타</option>
              </select>
            </div>

            <div className="privacy-box">
              <div className="privacy-text">
                <strong>[개인정보 수집 및 이용 동의]</strong>
                <br />
                1. 수집 목적: 사전 예약 신청, 서비스 오픈 알림, 경품 지급
                <br />
                2. 수집 항목: 이름, 휴대폰 번호, 이메일, 유입 경로
                <br />
                3. 보유 기간: 서비스 출시 및 경품 지급일로부터 1년
                <br />※ 동의 거부 시 사전 예약 혜택 지급이 제한될 수 있습니다.
              </div>

              <div className="checkbox-group">
                <input type="checkbox" id="agree_privacy" required />
                <label htmlFor="agree_privacy" className="checkbox-label">
                  <span>(필수)</span> 위 개인정보 수집 및 이용 목적에
                  동의합니다.
                </label>
              </div>
              <div className="checkbox-group">
                <input type="checkbox" id="agree_legal" required />
                <label htmlFor="agree_legal" className="checkbox-label">
                  <span>(필수)</span> 본 서비스는 현금 환급이 불가한 게임임을
                  확인했습니다.
                </label>
              </div>
            </div>

            <button type="submit" className="cta-button">
              오픈 멤버로 합류하기 🚀
            </button>
          </form>
          <div
            style={{
              textAlign: "center",
              marginTop: "24px",
              fontSize: "14px",
              color: "#666",
            }}
          >
            사전 예약은 선착순 마감될 수 있습니다.
          </div>
        </div>
      </section>

      {/* --- Floating CTA Button (Scroll triggered) --- */}
      <a
        href="#pre-register"
        className={`floating-cta ${showFloatingBtn ? "visible" : ""}`}
      >
        🚀 지금 바로 사전 예약하기
      </a>

      <footer>
        <p>&copy; 2025 Future League. All rights reserved.</p>
        <p>문의: futureleaguezto@gmail.com</p>
      </footer>
    </div>
  );
};

export default App;